import { Box, Typography, LinearProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import WarningIcon from '@material-ui/icons/ReportProblemOutlined';
import useDialog from '../../hooks/useDialog';
import useTranslation from 'next-translate/useTranslation';
import { useCallback, useState } from 'react';

function ConflictConnectionDialog({
  open,
  setOpen,
  onConfirm,
}) {
  const { t } = useTranslation('common');
  const [isResolving, setIsResolving] = useState(false);
  
  const handleClose = useCallback(() => {
    if (!isResolving) {
      setOpen(false);
    }
  }, [setOpen, isResolving]);
  
  const handleConfirm = useCallback(async () => {
    setIsResolving(true);
    
    try {
      await onConfirm?.();
    } catch (error) {
      // console.error('Conflict resolution failed:', error);
    } finally {
      setIsResolving(false);
      setOpen(false);
    }
  }, [setOpen, onConfirm]);

  return (
    <Dialog
      open={!!open}
      onClose={handleClose}
      aria-labelledby="conflict-connection-dialog"
      disableBackdropClick={isResolving}
      disableEscapeKeyDown={isResolving}
    >
      <Box p={1}>
        <DialogContent>
          <Box display="flex" alignItems="center">
            <Box pr={1}>
              <WarningIcon fontSize="large" color="secondary" />
            </Box>
            <Typography variant="h6">
              {t('Connection Conflict Detected')}
            </Typography>
          </Box>
          <Box py={2}>
            <Typography variant="subtitle1" align="center">
              {t('Connection conflict detected. This may be due to multiple active sessions or session mismatch.')}
            </Typography>
          </Box>
          <Box pb={2}>
            <Typography variant="subtitle2" align="center" color="textSecondary">
              {t('To resolve this issue, please disconnect from your phone device first, then reconnect to establish a fresh session.')}
            </Typography>
          </Box>
          {isResolving && (
            <Box py={2}>
              <LinearProgress />
              <Typography variant="caption" align="center" style={{ marginTop: 8, display: 'block' }}>
                {t('Resolving conflict...')}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            size="small" 
            variant="contained" 
            onClick={handleConfirm} 
            color="primary"
            disabled={isResolving}
          >
            {isResolving ? t('Resolving...') : t('Try Again')}
          </Button>
          {!isResolving && (
            <Button size="small" onClick={handleClose}>
              {t('Cancel')}
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
}

export default function useConflictConnectionDialog() {
  return useDialog(ConflictConnectionDialog);
}